export default "__VITE_ASSET__x0c46qTV__"